/**
 * approvalBindingVocabulary — one wording for one deployment fact.
 *
 * The approval spine states that an approval is bound to the exact action, target and input it was
 * granted for, so a change to any of them needs a new approval. That is the *strict* position:
 * `approval_service.verify_token` enforces it only while `APPROVAL_ALLOW_LEGACY_UNBOUND_TOKENS` is
 * False. While it is True (the pilot default) a token with no `request_hash` skips the tamper check
 * entirely, so an approval bound to nothing is accepted however the payload changed. The switch is a
 * CLAUDE.md §8 hard-gate item and is not flipped here — the workspace payload reports where it
 * stands, and every surface that states the binding as this deployment's runtime rule imports this
 * wording rather than restating the fact.
 *
 * The switch is named the way the product already names it (`PilotAcceptancePage`'s
 * `strict_approval_token_binding` label), so an operator who has seen the readiness screen
 * recognises the same fact here.
 */

export const APPROVAL_BINDING_NOT_ENFORCED_NOTE =
  "אכיפת קישור אסימון האישור לבקשת הביצוע כבויה כרגע — אסימון אישור שאינו מקושר לבקשה מתקבל גם אם הפעולה, היעד או הקלט שונו אחרי האישור.";

/**
 * The note that must accompany a stated approval-payload binding, or null when none is owed.
 *
 * One gate, and only one: an explicit `true` silences it. The fact is a safety disclosure, so a
 * payload that never carried it errs toward disclosing — the binding claim is static product copy
 * and is rendered whether or not the server stated the configuration, so an unstated configuration
 * must not read as the enforced one. Disclosing on a build that *does* enforce the binding would be
 * the mirror-image lie, which is what the `true` gate prevents.
 */
export function approvalBindingNote(capabilities) {
  return capabilities?.approval_binding_enforced === true ? null : APPROVAL_BINDING_NOT_ENFORCED_NOTE;
}
